import { applicationsTypes } from '../actions/_applications_actions';

const applicationsDefault = [];

export default (state = applicationsDefault, action) => {
  switch (action.type) {
    case applicationsTypes.GETTING_APPLICATIONS:
      return [...action.history];
    default:
      return state;
  }
};
